import { useState } from 'react'
import { Menu, X, Bell, User, LogOut, Settings } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContextTest'

function Header({ setSidebarOpen, user }) {
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const { logout } = useAuth()

  const handleLogout = async () => {
    await logout()
    setUserMenuOpen(false)
  }

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-secondary-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-secondary-700 lg:hidden"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <Menu className="h-6 w-6" aria-hidden="true" />
      </button>

      {/* Separator */}
      <div className="h-6 w-px bg-secondary-200 lg:hidden" aria-hidden="true" />

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="relative flex flex-1"></div>
        <div className="flex items-center gap-x-4 lg:gap-x-6">
          {/* Notifications */}
          <button
            type="button"
            className="-m-2.5 p-2.5 text-secondary-400 hover:text-secondary-500"
          >
            <span className="sr-only">View notifications</span>
            <Bell className="h-6 w-6" aria-hidden="true" />
          </button>

          {/* Separator */}
          <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-secondary-200" aria-hidden="true" />

          {/* Profile dropdown */}
          <div className="relative">
            <button
              type="button"
              className="-m-1.5 flex items-center p-1.5"
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <span className="sr-only">Open user menu</span>
              <div className="h-8 w-8 rounded-full bg-primary-600 flex items-center justify-center">
                <span className="text-base font-medium text-white">
                  {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
                </span>
              </div>
              <span className="hidden lg:flex lg:items-center">
                <span className="ml-4 text-base font-semibold leading-6 text-secondary-900" aria-hidden="true">
                  {user?.firstName} {user?.lastName}
                </span>
              </span>
            </button>

            {userMenuOpen && (
              <div className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-secondary-900/5 focus:outline-none">
                <div className="px-3 py-2 text-base text-secondary-500 border-b border-secondary-100">
                  <div className="font-medium text-secondary-900">{user?.firstName} {user?.lastName}</div>
                  <div className="text-xs text-secondary-500">{user?.role?.name}</div>
                </div>
                <a
                  href="/profile"
                  className="flex items-center gap-x-2 px-3 py-2 text-base leading-6 text-secondary-900 hover:bg-secondary-50"
                >
                  <User className="h-4 w-4" />
                  Profile
                </a>
                <a
                  href="/settings"
                  className="flex items-center gap-x-2 px-3 py-2 text-base leading-6 text-secondary-900 hover:bg-secondary-50"
                >
                  <Settings className="h-4 w-4" />
                  Settings
                </a>
                <button
                  onClick={handleLogout}
                  className="flex w-full items-center gap-x-2 px-3 py-2 text-base leading-6 text-secondary-900 hover:bg-secondary-50"
                >
                  <LogOut className="h-4 w-4" />
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
